import React from "react";
import { motion } from "framer-motion";
import { FileText, GraduationCap } from "lucide-react";
import SidebarGalleryPage from "../Main/Sidebargallery";
import AdmissionForm from "./AdmissionForm";

export default function CampusSection() {
  return (
    <div className="min-h-screen p-4 bg-gray-100">
      {/* Main Content */}
      <div className="flex flex-col w-full ">
        {/* Left Column - Admission Process Section */}
        <motion.div
          className="lg:w-full"
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.5 }}
        >
          <div className="space-y-6">
            {/* Section Header */}
            <div className="">
              {/* Image Inside Box */}
              {/* <div className="flex justify-center w-full mb-5">
                <img
                  src="https://cdn1.expresscomputer.in/wp-content/uploads/2015/06/14142939/mobile-roaming-BSNL620400.jpg"
                  alt="Admission Process"
                  className="rounded-lg p-2 border-4 border-teal-500 w-full max-w-[700px] object-cover"
                />
              </div> */}

              <div className="p-2 border-4 border-teal-500 rounded-lg">
                  <h2 className="text-xl font-bold mb-4 flex items-center gap-2 bg-[#00BFA5] text-white rounded-sm w-full p-4">
                    <GraduationCap className="w-6 h-6" />
                    Admission Process
                  </h2>
                  {/* Description */}
                  <motion.p
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: 0.2 }}
                    className="p-2 leading-relaxed text-gray-700"
                  >
                  <div className=" ">
      <h2 className="text-2xl font-bold text-center text-blue-600 mb-4">
        Admission Procedure
      </h2>

      <div className="space-y-4">
        {[
         {
          en: (
            <>
              Step1: Fill the Admission Registration form through{" "}
              <a
                href="http://dte.mponline.gov.in"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 underline font-medium"
              >
                MP Online
              </a>{" "}
              or through{" "}
              <a
                href="http://rgpvdiploma.in"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 underline font-medium"
              >
                DTE Admission Portal
              </a>.
            </>
          ),
          hi: (
            <>
              चरण 1:{" "}
              <a
                href="http://dte.mponline.gov.in"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 underline font-medium"
              >
                एमपी ऑनलाइन
              </a>{" "}
              या{" "}
              <a
                href="http://rgpvdiploma.in"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 underline font-medium"
              >
                डीटीई प्रवेश पोर्टल
              </a>{" "}
              के माध्यम से प्रवेश पंजीकरण फॉर्म भरें।
            </>
          ),
        },
          {
            en: "Step2: Pay the registration Fee.",
            hi: "चरण 2: पंजीकरण शुल्क का भुगतान करें।"
          },
          {
            en: "Step3: Wait for the auto verification or go to the nearest help center for manual verification of the documents as per the given instructions on the registration slip.",
            hi: "चरण 3: ऑटो सत्यापन की प्रतीक्षा करें या दस्तावेज़ों के मैन्युअल सत्यापन के लिए निकटतम सहायता केंद्र पर जाएं।"
          },
          {
            en: "Step4: After document verification, pay the choice filling fee and lock your choices for the courses and the institutes.",
            hi: "चरण 4: दस्तावेज़ सत्यापन के बाद, विकल्प भरने के शुल्क का भुगतान करें और पाठ्यक्रमों और संस्थानों के लिए अपनी पसंद को लॉक करें।"
          },
          {
            en: "Step5: Merit list will be prepared on the basis of PPT score or 10th Percentage.",
            hi: "चरण 5: पीपीटी स्कोर या 10वीं प्रतिशत के आधार पर मेरिट सूची तैयार की जाएगी।"
          },
          {
            en: "Step6: Institute and course (Branch) will be allotted to the students.",
            hi: "चरण 6: छात्रों को संस्थान और पाठ्यक्रम (शाखा) आवंटित किया जाएगा।"
          },
          {
            en: "Step7: Visit your allotted institute along with your original documents, one set of photocopies, two passport size photographs, registration form, choice filling form and allotment letter.",
            hi: "चरण 7: अपने मूल दस्तावेजों के साथ अपने आवंटित संस्थान में जाएं और सभी दस्तावेजों की फोटोकॉपी का एक सेट, दो पासपोर्ट आकार के फोटो, पंजीकरण फॉर्म, पसंद भरने का फॉर्म और आवंटन पत्र प्रस्तुत करें।"
          },
          {
            en: "Step8: Fill the Admission form at the institute and then pay your Admission fee. Your Admission is Done.",
            hi: "चरण 8: उस संस्थान में प्रवेश प्रपत्र भरें और फिर अपने प्रवेश शुल्क का भुगतान करें। आपका एडमिशन हो गया है।"
          }
        ].map((step, index) => (
          <div key={index} className=" bg-gray-100">
            <p className="font-semibold">{step.en}</p>
            <p className="text-gray-600">{step.hi}</p>
            <hr/>
          </div>
        ))}
      </div>

      <div className="mt-6 text-center border font-bold">
        <p className="text-sm">
        For more information about the courses visit RGPV website{' '}
          <a href="http://rgpvdiploma.in" className="text-blue-600 font-medium" target="_blank" rel="noopener noreferrer">
            RGPV website
          </a>{' '}
         
        </p>
      </div>
      <div className="mt-6 text-center border font-bold">
        <p className="text-sm">
        For more information about the online counseling process please visit the website{' '}
         
        
          <a href="http://dte.mponline.gov.in" className="text-blue-600 font-medium" target="_blank" rel="noopener noreferrer" >
            DTE Admission Portal
          </a>.
        </p>
      </div>
      <br/>
      <br/>
    </div>
                 
                 
                    {/* <b className="md:text-2xl">PPT (Pre Polytechnic Test) Courses:</b>
                    <ul className="mt-2">
                      <li>
                      <p className=""><a className="font-semibold text-blue-600 underline" href="http://localhost:3000/department/cse">1. Computer Science </a>is a 3 years diploma course with intake of 60. minimum qualification is 10th pass to take admission in this diploma course. For more details about this course.</p>
                      </li>

                      <br></br>
                      <li>
                      <p className=""><a className="font-semibold text-blue-600 underline" href="http://localhost:3000/department/mom">2. Modern Office Management  </a>is a 3 years diploma course with intake of 60. minimum qualification is 12th pass to take admission in this diploma course. For more details about this course</p>
                      </li>
                    </ul> */}
                  </motion.p>

                  {/* Links Section */}
                  <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.3 }}
                    // className=""
                  >
                   {/* <div className="p-2">
                   <h3 className="mb-2 text-lg font-bold ">To Know More:</h3>
                    <div className="space-y-2">
                      <a
                        href="https://www.rgpvdiploma.in"
                        target="_blank"
                        rel="noreferrer"
                        className="block text-blue-600 underline"
                      >
                        RGPV: www.rgpvdiploma.in
                      </a>
                      <a
                        href="https://www.dte.mponline.gov.in"
                        target="_blank"
                        rel="noreferrer"
                        className="block text-blue-600 underline"
                      >
                        DTE: www.dte.mponline.gov.in
                      </a>
                    </div>
                   </div> */}
                  </motion.div>
              </div>

              {/* Important Links Section */}
              {/* <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.4 }}
                className="mt-4 p-4 rounded-lg border-[#00BFA5] border-4"
              >
                <h3 className="text-lg font-bold text-[#00BFA5]">Important Links:</h3>
                <div className="flex flex-wrap gap-4 mt-2">
                  <a
                    href="https://www.gwpcs.org/img/general%20Instruction.pdf"
                    target="_blank"
                    rel="noreferrer"
                    className="flex items-center gap-2 px-3 py-2 text-sm text-white transition duration-300 bg-red-500 rounded-lg hover:bg-red-600"
                  >
                    <FileText className="w-5 h-5" />
                    General Instruction
                  </a>
                  <a
                    href="https://www.gwpcs.org/img/Rulebook.pdf"
                    target="_blank"
                    rel="noreferrer"
                    className="flex items-center gap-2 px-3 py-2 text-sm text-white transition duration-300 bg-red-500 rounded-lg hover:bg-red-600"
                  >
                    <FileText className="w-5 h-5" />
                    Rulebook
                  </a>
                </div>
              </motion.div> */}
            </div>
          </div> <a href="https://dte.mponline.gov.in/portal/services/onlinecounselling/counshomepage/home.aspx">
      <button className=" mt-6 bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded-lg block mx-auto">Admission registration (NPPT)-Click Here</button>
      </a>
        </motion.div>

        {/* Right Column - Gallery */}
        {/* <SidebarGalleryPage /> */}
      </div>
      {/* <AdmissionForm/> */}
     </div>
  );
}
